<ng-container *transloco="let t; lang: 'en|static' read: 'certified_digitalskillsauthority_org.header'">
  <div class="header-container">
    <div class="header-logo-container">
      <a [attr.aria-label]="t('aria_issuer_link')"
        [href]="'http://digitalskillsauthority.org'"
        target="_blank">
        <img [alt]="t('issuer_logo')"
          src="/assets/themes/certified.digitalskillsauthority.org/images/header_logo.png">
      </a>
    </div>

    <div class="menu-container">
      <sl-header-menu [extraDynamicMenuItems]="extraHeaderLinks"></sl-header-menu>
    </div>
  </div>
</ng-container>